import axios, {AxiosResponse} from 'axios';
import {ISearchDialogue} from '../search/interfaces';

export const getSearchDialoguesApi = (): Promise<AxiosResponse<ISearchDialogue[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/xpedition/search/list`
  );
};

export const getSearchDialogueApi = (id: number): Promise<AxiosResponse<ISearchDialogue>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/xpedition/search/${id}`
  );
};

export const createSearchDialogueApi = (dialogue: ISearchDialogue, lang: string): Promise<AxiosResponse<ISearchDialogue>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/xpedition/search/add`,
    {
      name: dialogue.dialogName,
      userDate: dialogue.dialogUserDate,
      language: lang
    }
  );
};

export const editSearchDialogueApi = (dialogue: ISearchDialogue): Promise<AxiosResponse<{ value: string }>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/xpedition/search/edit`,
    {
      id: dialogue.dialogId,
      name: dialogue.dialogName,
      userDate: dialogue.dialogUserDate
    }
  );
};
